/*
 * Floretta product add-ons (see snippets/floretta-product-addons.liquid).
 * A ticked add-on's fields get form="<product form id>", so District's Add to cart sends them
 * with the product; unticked, they belong to no form and aren't sent. Picking an option or
 * changing the quantity ticks it.
 * While a ticked add-on is still on "Choose a …", Add to cart is stopped with a message.
 */
(() => {
  if (customElements.get("product-addons")) return;

  class ProductAddons extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addons = [...this.querySelectorAll("[data-addon]")];

      this.addons.forEach((addon) => {
        const toggle = addon.querySelector("[data-addon-toggle]");
        const select = addon.querySelector("[data-addon-variant]");
        const quantity = addon.querySelector("[data-addon-quantity]");
        const sync = () => {
          addon.querySelectorAll("[data-addon-field]").forEach((field) => {
            if (toggle.checked) field.setAttribute("form", this.dataset.formId);
            else field.removeAttribute("form");
          });
          if (!toggle.checked || !select || select.value) this.setInvalid(addon, false);
        };
        toggle.addEventListener("change", () => {
          sync();
          if (toggle.checked && select && !select.value) select.focus();
        });
        if (select) {
          select.addEventListener("change", () => {
            const price = select.selectedOptions[0]?.dataset.price;
            if (price) addon.querySelector("[data-addon-price]").textContent = price;
            toggle.checked = true;
            sync();
          });
        }
        // District's −/+ buttons fire change on the input.
        quantity.addEventListener("change", () => {
          toggle.checked = true;
          sync();
        });
        // The browser may restore a ticked box or a choice on Back.
        sync();
      });

      // Capture phase on document runs before District's submit handler on the form.
      document.addEventListener(
        "submit",
        (event) => {
          // Not event.target.id: the form has an input named "id", which shadows it.
          if (event.target.getAttribute("id") !== this.dataset.formId) return;
          // A typed-in 0, blank or fraction would make Shopify reject the whole add.
          this.querySelectorAll("[data-addon-quantity]").forEach((input) => {
            const value = Math.floor(Number(input.value));
            input.value = value >= 1 ? value : 1;
          });
          const missing = this.addons.filter((addon) => {
            const select = addon.querySelector("[data-addon-variant]");
            return addon.querySelector("[data-addon-toggle]").checked && select && !select.value;
          });
          if (!missing.length) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          missing.forEach((addon) => this.setInvalid(addon, true));
          missing[0].querySelector("[data-addon-variant]").focus();
        },
        true
      );
    }

    setInvalid(addon, invalid) {
      addon.classList.toggle("is-invalid", invalid);
      const error = addon.querySelector("[data-addon-error]");
      if (error) error.hidden = !invalid;
    }
  }

  customElements.define("product-addons", ProductAddons);
})();
